import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { setGlobal, getGlobal, useGlobal } from 'reactn';
import { notification } from 'antd';
import api from '../../../api';
import Navbar from '../../common/navbar/Navbar';
import Alerts from '../../common/alerts/Alerts';
import Dashboard from '../dashboard/Dashboard';
import FindProperty from '../findProperty/FindProperty';
import PastBills from '../pastBills/PastBills';
import Profile from '../profile/Profile';
import { Helmet } from 'react-helmet';

const TAWK_WIDGET_ID = process.env.REACT_APP_TAWK_WIDGET_ID;

const fetchSiteDetails = async () => {
  const siteDetails = await api.getSiteDetails();
  const faqs = await api.getFaqs();
  const { siteDetails: defaultSiteDetails } = getGlobal();
  setGlobal({
    siteDetails: {
      ...defaultSiteDetails,
      ...siteDetails,
    },
    faqs,
  });
};

const fetchAccountDetails = async (setLoading) => {
  setLoading(true);
  await api.fetchCurrentAccount();
  setLoading(false);
};

const Layout = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const [user] = useGlobal('user');

 useEffect(() => {
  const fetchInitialData = async (setLoading) => {
    try {
      const user = await api.getUser();
      const _serviceAccounts = await api.getServiceAccounts();
      const defaultAccountNumber =
        user.default_account_number !== ''
          ? user.default_account_number
          : _serviceAccounts[0]?.data?.ACCOUNT;

      const selectedServiceAccountIndex = _serviceAccounts.findIndex(
        (e) => e?.data?.ACCOUNT === parseInt(defaultAccountNumber, 10)
      );

        setGlobal({
         user,
         defaultAccountNumber,
         serviceAccounts: _serviceAccounts,
         selectedServiceAccountIndex:
            selectedServiceAccountIndex === -1 ? 0 : selectedServiceAccountIndex,
        });
        setLoading(false);
       } catch (error) {
        if (error.response) {
         notification.error({
           message: 'Your session has timed out.  Please log in again.',
         });
         history.push('/auth/signin');
          api.signout();
       }
      } 
    };
    fetchInitialData(setLoading);
    fetchSiteDetails();
  }, [history]);

  useEffect(() => {
    fetchAccountDetails(setLoadingDetails);
  }, [selectedServiceAccountIndex]);

  // Tawk api license and functionality only availiable in Production
  const Tawk_API = Tawk_API || {};
  Tawk_API.visitor = {
    name: `${user?.first_name} ${user?.last_name}`,
    email: user?.email,
  };
  const Tawk_LoadStart = new Date();
  const tawkInit = () => {
    const s1 = document.createElement('script');
    const s0 = document.getElementsByTagName('script')[0];
    s1.async = true;
    s1.src = `https://embed.tawk.to/5f0ca91c67771f3813c0f6b0/${TAWK_WIDGET_ID}`;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  };

  return (
    <div className="min-h-screen">
      <Helmet>
        <script type="text/javascript">{tawkInit()}</script>
      </Helmet>
      <Navbar />
      <Alerts />
      {loading || loadingDetails ? (
        <div className="w-full min-h-screen flex items-center justify-center">
          <Spin tip="Loading accounts. Please stand by." />
        </div>
      ) : (
        <Switch>
          <Route path="/user/find-property" exact component={FindProperty} />
          <Route path="/user/dashboard" exact component={Dashboard} />
          <Route path="/user/past-bills" exact component={PastBills} />
          <Route path="/user/profile" exact component={Profile} />
        </Switch>
      )}
    </div>
  );
};

export default Layout;
